import { GetUserDocument } from '__generated__/graphql';

const GET_USER = GetUserDocument;

export default GET_USER;
